export default {
  state: () => ({
    loggedIn: false,
    loginSchema: [],
    resetPasswordSchema: [],
    forgotPasswordSchema: [],
    token: null,
    passwordReset: null
  })
}



// WEBPACK FOOTER //
// ./src/app/store/login/config.js